import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth.service';

export interface ExportacaoRegistro {
  registroId: string;
  tipoRegistro: string;
  status: string;
  statusExportacao?: string | null;
  numeroOs?: string | null;
  nomeConsumidor?: string | null;
  matricula?: string | null;
  documento?: string | null;
  referencia?: string | null;
  dataHoraRegistro?: string | null;
  dataHoraInicioAnalise?: string | null;
  exportado: boolean;
  dataUltimaTentativaExportacao?: string | null;
  dataExportacao?: string | null;
  versaoArquivo?: string | null;
  logradouro?: string | null;
  numero?: string | null;
  bairro?: string | null;
  cidade?: string | null;
}

export interface PaginacaoExportacaoResponse {
  itens: ExportacaoRegistro[];
  totalItens: number;
  totalPesquisa?: number;
  paginaAtual: number;
  totalPaginas: number;
  tamanhoPagina: number;
}

export interface ExportacaoPainelFiltros {
  exportado?: boolean | null;
  cidade?: string;
  bairro?: string;
  numeroOs?: string;
  pagina?: number;
  tamanhoPagina?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ExportacaoService {
  private readonly apiUrl = `${environment.cedaeapp}/ExportacaoTxt`;

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService
  ) {}

  private getAuthOptions() {
    const token = this.authService.getToken();

    if (!token) {
      return {};
    }

    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`
      })
    };
  }

  obterPainel(filtros: ExportacaoPainelFiltros = {}): Observable<PaginacaoExportacaoResponse> {
    let params = new HttpParams()
      .set('pagina', String(filtros.pagina ?? 1))
      .set('tamanhoPagina', String(filtros.tamanhoPagina ?? 50));

    if (filtros.exportado !== undefined && filtros.exportado !== null) {
      params = params.set('exportado', String(filtros.exportado));
    }

    if (filtros.cidade?.trim()) {
      params = params.set('cidade', filtros.cidade.trim());
    }

    if (filtros.bairro?.trim()) {
      params = params.set('bairro', filtros.bairro.trim());
    }

    if (filtros.numeroOs?.trim()) {
      params = params.set('numeroOs', filtros.numeroOs.trim());
    }

    return this.http.get<PaginacaoExportacaoResponse>(`${this.apiUrl}/painel`, {
      params,
      ...this.getAuthOptions()
    });
  }

  reenviarRegistro(registroId: string, tipoRegistro: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/manual/item`, {
      registroId,
      tipoRegistro
    }, this.getAuthOptions());
  }

  desfazerExportacaoSucesso(registroId: string, tipoRegistro: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/superadmin/desfazer-sucesso`, {
      registroId,
      tipoRegistro
    }, this.getAuthOptions());
  }
}
